<template>
  <div class="input">
    <div class="input__inner">
      <div class="input__control" :class="controlClasses">
        <input
          v-mask="maskOptions"
          class="input__native"
          :aria-label="label"
          :autocomplete="autocomplete"
          :disabled="disabled"
          :name="name"
          :placeholder="placeholder"
          :type="type"
          :inputmode="inputmode"
          :value="value"
          @blur="blur"
          @change="updateValue"
          @focus="focus"
          @input="updateValue"
        />
      </div>

      <div v-if="postfix" class="input__postfix">
        {{ postfix }}
      </div>
    </div>

    <transition name="fade">
      <div v-show="errorMessage && !noError" class="input__error">
        {{ errorMessage }}
      </div>
    </transition>
    <transition name="fade">
      <div v-show="infoMessage && !errorMessage && !noError" class="input__info">
        {{ infoMessage }}
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';
import Inputmask from 'inputmask';
import { ValidateMixin } from '@/mixins';

export default Vue.extend({
  name: 'VInput',

  mixins: [ValidateMixin],

  props: {
    autocomplete: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    inputmode: {
      type: String,
      default: '',
    },

    label: {
      type: String,
      default: '',
    },

    mask: {
      type: [String, Object],
      default: null,
    },

    tellMask: {
      type: String,
      default: '',
    },

    name: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    postfix: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: 'text',
    },

    noError: {
      type: Boolean,
      default: false,
    },

    infoMessage: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      focused: false,
      error: false,
      errorMessage: '',
    };
  },

  computed: {
    controlClasses() {
      return {
        'input__control--error': this.error,
        'input__control--focused': this.focused,
        'input__control--disabled': this.disabled,
        'input__control--postfix': this.postfix,
      };
    },

    maskOptions() {
      if (!this.mask) {
        return null;
      }

      return typeof this.mask === 'string' ? { mask: this.mask } : this.mask;
    },
  },

  methods: {
    blur() {
      this.focused = false;

      if (this.validateOn.includes('blur')) {
        this.validate();
      }

      this.$emit('blur');
    },

    focus() {
      this.focused = true;
      this.$emit('focus');
    },

    updateValue(e) {
      this.$emit('input', e.target.value);
    },
  },

  mounted() {
    const input = this.$el.querySelector('input');
    const inputType = this.inputmode || this.type;

    // if (inputType === 'tel') {
    //   const im = new Inputmask('+7 (999) 999-9999');
    //   im.mask(input);
    // }
  },
});
</script>

<style lang="scss">
.input {
  display: inline-block;
  padding: 0;
}

.input__inner {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.input__control {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  position: relative;
  border-bottom: 1px solid #c8c7d5;
  color: #293048;
  font-size: 16px;
}

.input__native {
  flex-grow: 1;
  width: 100%;
  height: 44px;
  margin: 0;
  padding: 0 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 1;
  font-family: inherit;
  background: transparent;
  color: inherit;
  border: none;
  outline: none;
}

.input__native::placeholder {
  color: #9d9daf;
}

.input__postfix {
  flex-shrink: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 44px;
  color: #2f3960;
  border-bottom: 1px solid #c8c7d5;
}

.input__control:hover,
.input__control:hover + .input__postfix {
  border-color: #00cf6f;
}

.input__control--focused,
.input__control--focused + .input__postfix {
  border-color: #00cf6f;
}

.input__control--disabled,
.input__control--disabled + .input__postfix {
  opacity: 0.4;
}

.input__control--error {
  color: #ed0000;
}

.input__control--error,
.input__control--error:hover,
.input__control--error:focus,
.input__control--error + .input__postfix,
.input__control--error:hover + .input__postfix,
.input__control--error:focus + .input__postfix {
  border-color: #ed0000;
}

.input__error, .input__info {
  margin-top: 12px;
  color: var(--negative-color);
  font-weight: 500;
  font-size: 13px;
  line-height: 1.4;
}

.input__info {
  color: inherit;
}
</style>
